<template>
  <div
    class="rrbldract"
    draggable="false"
  >
    <div
      ref="hscrl_inner"
      class="rrbldract_actions no-scroll-track"
      :class="{ rrbldract_actions_large: l_solution.length <= 4 }"
      @wheel.stop="e => hscrl_wheelScroll(e)"
      @mousedown.stop="e => hscrl_dragScrollMousedown(e)"
    >
      <div
        v-for="(action, aIdx) in l_solution"
        :key="`${action.code}_${aIdx}`"
        class="rab_btn"
        :class="action.css_class"
        :style="useHex ? `background:${action.hex}` : ''"
      >
        <div class="rab_btn_name">
          {{ action.display_name || $t(`browse.${action.group_display_name}`) }}
          <span v-html="getBetHtml({ showBetsIn, a: action, simple: false })"></span>
        </div>
        <NumberInput
          class="z-index_2 numinput_white"
          :value="numFixed(action.strategy * 100)"
          :min="0"
          :max="100"
          :step="1"
          :decimals="0"
          style="
            --clr-focus: var(--clr-primary);
            font-size: 1rem;
            --input-height: 1.75rem;
            --input-clr-arrow-disabled: var(--clr-white-0);
          "
          @input="num => handleNumInput(num / 100, aIdx)"
        />
        <GwBtns
          :options="presets"
          class="gwbtns_horizontal_grey f-center"
          style="
            padding: 0 0.125rem;
            margin-top: 0.25rem;
            --gwbtn-weight: 600;
            --gwbtns-gap: 1px;
            --gwbtn-padding: 0 0.25rem;
            --gwbtn-clr-back: rgba(0, 0, 0, 0.25);
            --gwbtn-clr-back: rgba(255, 255, 255, 0.1);
            --gwbtn-clr-active-white: rgba(255, 255, 255, 0.2);
            --gwbtn-clr-hover-white: rgba(255, 255, 255, 0.2);
            --gwbtn-clr: var(--clr-white-0);
            bottom: 0;
            --gwbtns-wrap: wrap;
          "
          @click="(_e, item) => handleNumInput(item, aIdx)"
        >
          <template #default="{ item }">
            {{ item * 100 }}
          </template>
        </GwBtns>
      </div>
    </div>
    <RangeInput
      v-if="l_solution.length > 1"
      :values="
        l_solution.map(i => {
          return {
            id: i.id || i.code,
            cssStyle: useHex ? `--clr-input-back:${i.hex}` : '',
            cssClass: i.css_class,
            name: i.display_name,
            percentage: i.strategy,
          }
        })
      "
      :balance="1"
      @values:update="({ values }) => handleInput(values)"
    />
  </div>
</template>

<script>
import NumberInput from '@/components/lib/NumberInput'
import RangeInput from '@/components/lib/RangeInput'
import GwBtns from '@/components/lib/GwBtns'
import format_mix from '@/mixins/format_mix'
import { getGroupedActions, getUngroupedActions } from '@/helpers/grouping'
import { getEqualSolution } from '@/helpers/rangeBuilder'
import float_mix from '@/mixins/float_mix'
import horizontalScroll_mix from '@/components/HorizolnalScroller/horizontalScroll_mix'

export default {
  name: 'RangeBuilderActions',
  components: {
    NumberInput,
    RangeInput,
    GwBtns,
  },
  mixins: [format_mix, float_mix, horizontalScroll_mix],
  props: {
    solution: { default: () => [] },
    showBetsIn: String,
    useHex: Boolean,
    grouping: { default: () => [] },
  },
  emits: ['update:actions'],
  data() {
    this.presets = [0, 0.25, 0.5, 0.75, 1]
    return {}
  },
  methods: {
    balanceValues(actions, aIdx, min = 0, max = 1, total = 1) {
      const nextIdx = aIdx + 1 > actions.length - 1 ? 0 : aIdx + 1
      let l_total = actions.reduce((acc, i) => acc + i.strategy, 0)
      const balance = total - l_total
      let res = actions.map((i, idx) => {
        if (idx === aIdx) {
          return i
        }
        if (idx === nextIdx) {
          const str = i.strategy + balance
          if (str <= max && str >= min) {
            i.strategy = str
          }
          if (str < min) {
            i.strategy = 0
          }
          return i
        }
        return i
      })
      l_total = res.reduce((acc, i) => acc + i.strategy, 0)
      if (l_total.toFixed(10) !== total.toFixed(10)) {
        // console.log('balanceValues', l_total, total, res)
        return this.balanceValues(res, nextIdx)
      }

      res = res.map(i => {
        // https://stackoverflow.com/questions/21690070/javascript-float-comparison
        let num = Number(i.strategy.toFixed(10))
        num = num > max ? max : num < min ? min : num
        return {
          ...i,
          strategy: num,
        }
      })

      return res
    },
    handleNumInput(num, aIdx) {
      let res = [...this.l_solution]
      res = res.map((i, idx) => {
        if (idx === aIdx) {
          i.strategy = num
          return i
        }
        return i
      })

      res = this.balanceValues(res, aIdx)
      this.emitValues(res)
    },
    handleInput(values) {
      // console.log(values)
      // console.log('handleInput', num)
      const res = [...this.l_solution].map((i, idx) => ({
        ...i,
        strategy: values[idx].percentage,
      }))

      this.emitValues(res)
    },
    emitValues(res) {
      res = res.map((i, idx) => {
        if (i.actions) {
          i.actions = getEqualSolution({
            solution: i.actions,
            total: i.strategy,
          })
        }
        return i
      })

      if (!this.useHex) {
        res = getUngroupedActions({ actions: res })
      }
      this.$emit('update:actions', res)
    },
  },
  computed: {
    l_solution() {
      // console.log('l_solution', this.solution, this.grouping)
      const res = getGroupedActions({
        actions: this.solution,
        grouping: this.grouping,
        groupValues: ['strategy'],
        raisesFirst: true,
      })
      return res
    },
  },
}
</script>
<style lang="scss" scoped>
.rrbldract {
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
  flex: 1;
  cursor: default;
  &_actions {
    display: flex;
    gap: 0.25rem;
    min-height: 0;
    min-width: 0;
    flex: 1;
    max-width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    // flex-shrink: 0;
    .rab_btn {
      min-width: 8rem;
      display: flex;
      flex: 1;
      position: relative;
      overflow: hidden;
      flex-direction: column;
      gap: 0.25rem;
      font-weight: 500;
      font-size: 1.125rem;
      text-shadow: var(--action-btn-text-shadow);
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      &_name {
        color: var(--clr-white-0);
        text-align: center;
        padding: 0 0.25rem;

        --text-overflow: hidden;
        --line-clamp: 2;
        display: -webkit-box;
        -webkit-line-clamp: var(--line-clamp);
        -webkit-box-orient: vertical;
        overflow: var(--text-overflow);
      }
    }
    &_large {
      .rab_btn {
        font-size: 1.5rem;
      }
    }
  }
}
</style>
